export default __webpack_public_path__ + "static/hero-bg-1x-b725f21942e97f45c51254c0185bad9f.webp";